module.exports = "precision mediump float;\nuniform sampler2D previousTexture;\nuniform sampler2D uSampler;\nuniform float progress;\nvarying vec2 vTextureCoord;\nvarying vec2 vFilterCoord;\nvoid main()\n{\n  vec4 col = texture2D(previousTexture, vFilterCoord);\n  vec4 col2 = texture2D(uSampler, vTextureCoord);\n  gl_FragColor = mix(col, col2, progress);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/transition/shaders/crossfade.frag
// module id = 598
// module chunks = 0